<mat-toolbar class="bar-filler">
    <div></div>
</mat-toolbar>
<form class="small-margin">
    <mat-form-field class="fill-parent-width">
        <mat-label>{{'Pages.CarDescription.Form.Reference' | translate}}</mat-label>
        <input matInput type="text" placeholder="{{'Pages.CarDescription.Form.ReferenceEx' | translate}}" [(ngModel)]="carDescription.Reference" name="reference">
    </mat-form-field>
    <mat-form-field class="fill-parent-width">
        <mat-label>{{'Pages.CarDescription.Form.Model' | translate}}</mat-label>
        <input matInput type="text" placeholder="{{'Pages.CarDescription.Form.ModelEx' | translate}}" [(ngModel)]="carDescription.Model" name="neighbourhood">
    </mat-form-field>
    <mat-form-field class="fill-parent-width">
        <mat-label>{{'Pages.CarDescription.Form.Color' | translate}}</mat-label>
        <input matInput type="text" placeholder="{{'Pages.CarDescription.Form.Color' | translate}}" [(ngModel)]="carDescription.Color" name="street">
    </mat-form-field>
</form>
<mat-toolbar color="primary" class="top-bar">
    <button mat-icon-button (click)="back()">
        <mat-icon>arrow_back</mat-icon>
    </button>
    <div>{{'Pages.CarDescription.Title' | translate}}</div>
    <div class="filler"></div>
    <button mat-icon-button (click)="goOn()">
        <mat-icon>done</mat-icon>
    </button>
</mat-toolbar>